import React from 'react';
import { formatPrice, parsePrice } from '../../utils/priceUtils';

interface MenuItemCardProps {
  item: {
    pkId: string;
    name: string;
    price: number | string;
  };
  quantity?: number;
  onAdd: (item: any) => void;
  onIncrement?: (item: any) => void;
  onDecrement?: (item: any) => void;
}

export const MenuItemCard: React.FC<MenuItemCardProps> = ({ 
  item, 
  quantity = 0,
  onAdd,
  onIncrement,
  onDecrement 
}) => {
  return (
    <div
      className="
        w-full
        bg-[var(--card-bg,white)]
        border border-[var(--border-color)]
        rounded-lg
        px-3 py-2
        transition-all duration-200
        hover:shadow-md hover:-translate-y-[1px]
        active:scale-[0.99]
      "
    >
      <div className="flex items-center gap-3">

        {/* Name + Price */}
        <div className="flex-1 min-w-0">
          <h4 className="
            text-sm sm:text-base
            font-semibold
            text-[var(--text-primary)]
            truncate
          ">
            {item.name}
          </h4>

          <p className="
            text-xs sm:text-sm
            font-medium
            text-[var(--accent-color)]
          ">
            {formatPrice(parsePrice(item.price))}
          </p>
        </div>

        {/* Conditional: Add Button OR Quantity Controls */}
        {quantity === 0 ? (
          /* Add Button - Show when quantity is 0 */
          <button
            onClick={() => onAdd(item)}
            className="
              px-3 py-1
              text-xs sm:text-sm
              font-medium
              rounded-md
              bg-[var(--accent-color)]
              text-white
              shadow-sm
              hover:opacity-90
              transition
              whitespace-nowrap
            "
          >
            Add
          </button>
        ) : (
          /* Quantity Controls - Show when quantity > 0 - COMPACT VERSION */
          <div className="flex items-center gap-1">
            <button
              onClick={() => onDecrement?.(item)}
              className="
                w-6 h-6
                flex items-center justify-center
                rounded-full
                bg-gray-100
                hover:bg-gray-200
                text-[var(--text-primary)]
                text-xs
                font-bold
                transition
                active:scale-95
              "
              aria-label="Decrease quantity"
            >
              −
            </button>
            
            <span className="
              min-w-[1.5rem]
              text-center
              text-xs
              font-semibold
              text-[var(--text-primary)]
            ">
              {quantity}
            </span>
            
            <button
              onClick={() => onIncrement?.(item)}
              className="
                w-6 h-6
                flex items-center justify-center
                rounded-full
                bg-[var(--accent-color)]
                hover:opacity-90
                text-white
                text-xs
                font-bold
                transition
                active:scale-95
              "
              aria-label="Increase quantity"
            >
              +
            </button>
          </div>
        )}

      </div>
    </div>
  );
};
